export enum Status {
  ERROR = 'error',
  SUCCESS = 'success',
  WARNING = 'warning',
  LOADING = 'loading',
  INFO = 'info',
  BASIC = 'basic',
}
